/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function o(o) {
  var n;
  var l = o.layer;

  if ("floorInfo" in l && null != (n = l.floorInfo) && n.floorField && "floors" in o.view) {
    return r(o.view.floors, l.floorInfo.floorField);
  }

  return null;
}

function n(o, n) {
  var l;
  return "floorInfo" in n && null != (l = n.floorInfo) && l.floorField ? r(o, n.floorInfo.floorField) : null;
}

function l(o, n) {
  var l = n.definitionExpression;
  return o ? l ? "(".concat(l, ") AND (").concat(o, ")") : o : l;
}

function r(o, n) {
  if (null == o || !o.length) return null;
  var l = o.filter(function (o) {
    return "" !== o;
  }).map(function (o) {
    return "'".concat(o, "'");
  });
  return l.push("''"), "".concat(n, " IN (").concat(l.join(","), ") OR ").concat(n, " IS NULL");
}

export { l as combineFloorsDefinitionExpression, o as getFloorFilterClause, n as getLayerFloorFilterClause };